export default __webpack_public_path__ + "static/media/profile_defaultImg.122f9cf1.svg";